let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5mQob")).then(() => parcelRequire('lrDbV'));